import { Link, router } from '@inertiajs/react'
import { cn } from '@/lib/utils'
import type { EpisodeCard as EpisodeCardType } from '@/types'

const DIFFICULTY_COLORS = {
  beginner: 'bg-green-100 text-green-700',
  intermediate: 'bg-orange-100 text-orange-700',
  advanced: 'bg-red-100 text-red-700',
}

const THUMBNAIL_COLORS = [
  'bg-[#0d2b45]', 'bg-[#1e4d6e]', 'bg-[#1a3a2a]', 'bg-[#2a2a3a]',
]

interface Props {
  episode: EpisodeCardType
  index?: number
}

export default function EpisodeCard({ episode, index = 0 }: Props) {
  const bgColor = THUMBNAIL_COLORS[index % THUMBNAIL_COLORS.length]

  return (
    <div
      className="group block cursor-pointer"
      onClick={() => router.visit(`/episodes/${episode.slug}`)}
    >
      {/* Thumbnail */}
      <div className={cn('aspect-video rounded-lg mb-3 overflow-hidden', bgColor, 'relative')}>
        {episode.thumbnail_url ? (
          <img src={episode.thumbnail_url} alt={episode.title} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full" />
        )}
      </div>

      {/* Badges */}
      <div className="flex items-center gap-1.5 mb-1.5">
        <span className={cn('text-xs font-medium px-2 py-0.5 rounded-full capitalize', DIFFICULTY_COLORS[episode.difficulty])}>
          {episode.difficulty}
        </span>
        <span className={cn(
          'text-xs font-medium px-2 py-0.5 rounded-full',
          episode.is_free ? 'bg-green-100 text-green-700' : 'bg-rose-100 text-rose-600'
        )}>
          {episode.is_free ? 'Free' : 'Pro'}
        </span>
      </div>

      {/* Title */}
      <h3 className="font-semibold text-gray-900 text-sm leading-snug group-hover:text-brand transition-colors line-clamp-2">
        {episode.title}
      </h3>

      {/* Meta */}
      <p className="text-xs text-gray-400 mt-1">
        {episode.duration}
        {episode.tags.slice(0, 2).map(t => (
          <Link
            key={t.slug}
            href={`/topics/${t.slug}`}
            onClick={e => e.stopPropagation()}
            className="hover:text-brand hover:underline"
          > · {t.name}</Link>
        ))}
      </p>
    </div>
  )
}
